var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeTab === 0
    ? _c(
        "div",
        [
          _c("SingleEditObjectMainInfoCompanies", {
            attrs: {
              editableLabel: "Company *",
              editableInputOptions: _vm.allCompanies.data,
              editingData: _vm.editingData,
              data: !!_vm.selectedCompany.id ? _vm.selectedCompany : null
            },
            on: {
              "update-company": function($event) {
                return _vm.updateDataCompany($event)
              }
            }
          })
        ],
        1
      )
    : _vm.activeTab === 1
    ? _c(
        "div",
        [
          _c("SingleEditObjectMainInfoRoles", {
            attrs: {
              editableLabel: "Role *",
              editableInputOptions: _vm.allRoles.data,
              editingData: _vm.editingData,
              data: !!_vm.selectedRole.id ? _vm.selectedRole.id : null
            },
            on: {
              "update-roles": function($event) {
                return _vm.updateDataRole($event)
              }
            }
          })
        ],
        1
      )
    : _vm.activeTab === 2
    ? _c("div", [
        _c(
          "div",
          { staticClass: "tableDivContainer" },
          [
            _c("Table", {
              attrs: {
                checkbox: false,
                loading: _vm.loading,
                headers: _vm.headers,
                items: _vm.workspaces,
                sortable: true,
                emitRowClickBusEvent: false
              },
              on: {
                onScrollBottom: _vm.onScrollBottom,
                onScrollTop: _vm.onScrollTop,
                sortClick: _vm.onSortClick,
                selectedRows: function($event) {
                  return _vm.onCheckboxClick($event)
                }
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd5e4220", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd5e4220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Accounts/UserSpecificInfoList.vue
// module id = null
// module chunks = 